import React from "react";

import "./Header.css";
import { SubHeading } from "../../components";
import { images } from "../../constants";

const Header = () => (
	<div className="app__header app__wrapper section__padding" id="home">
		<div className="app__wrapper_info">
			<SubHeading title="Chase The New Flavour" />
			<h1 className="app__header-h1">
				The key <br /> to Fine <br /> Dinning
			</h1>
			<p className="p__opensans">
				Welcome to Mary Matha Catering and Event Management, where exceptional
				catering and event management services await to make your special
				occasions truly unforgettable. Step into a world where meticulous
				planning, impeccable execution, and exquisite culinary creations combine
				to create moments that will be cherished for a lifetime.
			</p>
		</div>
		<div className="app__wrapper_img">
			<img src={images.welcome} alt="welcome" loading="lazy" />
		</div>
	</div>
);
export default Header;
